import Header from './Header';
import { Desktop } from './Desktop';
import { Mobile } from './Mobile';

export {
	Desktop,
	Mobile,
};

export default Header;